export default __webpack_public_path__ + "static/media/banner.h264.compressed.e8590545.mp4";